export * from '@primeuix/themes/material/image';
export { default } from '@primeuix/themes/material/image';
